<div class="row main-content">
    <div class="w15">
        <div class="sidebar">
            <ul>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || !isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" class="active" routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/Save-Quotes"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
                <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
                <li routerLink="/dashboard/forms"><img src="./assets/images/file-text.svg"><a>POLICY DOCUMENTS</a></li>
                <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
                <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
                <li routerLink="/dashboard/resources"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
            </ul>
        </div>
    </div>
    <div class="w85">
        <div>
            <div class="whitebox p-3 posFixed">
              <label class="bold fs-18 m-0 cp" (click)="backToPolicySearch()">Policy Search&nbsp;>&nbsp;</label>    
              <label class="bold fs-18 m-0 cp" (click)="backToPolicyDetails()">{{policyNumber}}</label>
              <label class="bold fs-20 txt-red m-0">&nbsp;>&nbsp;Edit Billing Information</label>
            </div>
            <div class="clear40"></div>
            <div class="clear20"></div>
            <div class="p-3">
              <div class="whitebox1">
                <label class="bold fs-16 txt-red m-0">Current Credit Card Information</label>
                <div class="clear5"></div>
                <div class="border-bottom"></div>
                <div class="clear5"></div>
                <div class="row">
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Card Type</label>
                        <div class="bold fs-14 purple">{{cardType}}</div>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Card Number</label>
                        <div class="bold fs-14 purple">{{sslCardNumber}}</div>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Exp (MM/YY)</label>
                        <div class="bold fs-14 purple">{{sslExpDate}}</div>
                    </div>
                </div>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                        <label class="semi-bold fs-14 txt-red warningBox">Update Credit Card Information:<span class="regular fw500">&nbsp;To Use current credit card, Leave this section blank</span></label>
                    </div>
                </div>
                <div class="clear10"></div>
                <div class="row">
                  <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <label class="regular fs-14 txt-black">Card Type</label>
                      <div>
                          <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select">
                              <ng-option>Credit Card</ng-option>
                              <ng-option>Debit Card</ng-option>
                          </ng-select>
                      </div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                    <label class="regular fs-14 txt-black">Card Number</label>
                    <div>
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here">
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                    <label class="regular fs-14 txt-black">Expiry (MM/YY)</label>
                    <div>
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="MM/YY">
                    </div>
                  </div>
                </div>
                <div class="clear20"></div>
                <button type="button" class="splitPaymentbtn fs-14 bold">Update Credit card</button>
              </div>
              <div class="clear20"></div>
              <div class="whitebox1">
                <label class="bold fs-16 txt-red m-0">Current Credit Card Information</label>
                <div class="clear5"></div>
                <div class="border-bottom"></div>
                <div class="clear5"></div>
                <div class="row">
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Status</label>
                        <div class="bold fs-14 purple">Active</div>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Charges Remaining</label>
                        <div class="bold fs-14 purple">10 of 11</div>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Total Billing</label>
                        <div class="bold fs-14 purple">$1031</div>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                      <label class="regular fs-14 txt-lightblack2">Amount Paid</label>
                      <div class="bold fs-14 purple">$1.037</div>
                  </div>
                  <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                    <label class="regular fs-14 txt-lightblack2">Amount Remaining</label>
                    <div class="bold fs-14 purple">$1.037.21</div>
                </div>
                </div>
                <div class="clear10"></div>
                <label class="fs-14 semi-bold green geenbtn">Set Monthly Payment Schedule to Hold</label>
                <div class="clear10"></div>
                <div class="tableheadFix">
                  <table id="tableheadFixMonthlyPay" class="w100">
                      <thead class="nowrap">
                          <tr>
                              <th>
                                  <div class="d-flex flex-row align-items-center">
                                      <span>DATE</span>
                                      <!-- <div class="d-flex flex-column ml-4">
                                          <i class="fa fa-caret-up"></i>
                                          <i class="fa fa-caret-down"></i>
                                      </div> -->
                                  </div>
                              </th>
                              <th>
                                  <div class="d-flex flex-row align-items-center">
                                      <span>Status</span>
                                      <!-- <div class="d-flex flex-column ml-4">
                                          <i class="fa fa-caret-up"></i>
                                          <i class="fa fa-caret-down"></i>
                                      </div> -->
                                  </div>
                              </th>
                              <th>
                                  <div class="d-flex flex-row align-items-center">
                                      <span>Premium</span>
                                      <!-- <div class="d-flex flex-column ml-4">
                                          <i class="fa fa-caret-up"></i>
                                          <i class="fa fa-caret-down"></i>
                                      </div> -->
                                  </div>
                              </th>
                              <th>
                                  <div class="d-flex flex-row align-items-center">
                                      <span>Tax</span>
                                      <!-- <div class="d-flex flex-column ml-4">
                                          <i class="fa fa-caret-up"></i>
                                          <i class="fa fa-caret-down"></i>
                                      </div> -->
                                  </div>
                              </th>
                              <th>
                                  <div class="d-flex flex-row align-items-center">
                                      <span>Billing Fee</span>
                                      <!-- <div class="d-flex flex-column ml-4">
                                          <i class="fa fa-caret-up"></i>
                                          <i class="fa fa-caret-down"></i>
                                      </div> -->
                                  </div>
                              </th>
                              <th>
                                  <div class="d-flex flex-row align-items-center">
                                      <span>Admin Fee</span>
                                      <!-- <div class="d-flex flex-column ml-4">
                                          <i class="fa fa-caret-up"></i>
                                          <i class="fa fa-caret-down"></i>
                                      </div> -->
                                  </div>
                              </th>
                              <th>
                                <div class="d-flex flex-row align-items-center">
                                    <span>Payment Amt</span>
                                    <!-- <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up"></i>
                                        <i class="fa fa-caret-down"></i>
                                    </div> -->
                                </div>
                            </th>
                          </tr>
                      </thead>
                      <tbody class="">
                          <tr>
                              <td>Dummy</td>
                              <td>Dummy</td>                      
                              <td>Dummy</td>                      
                              <td>Dummy</td>                      
                              <td>Dummy</td> 
                              <td>Dummy</td>   
                              <td>Dummy</td>                   
                          </tr>
                          <tr>
                            <td>Dummy</td>
                            <td>Dummy</td>                      
                            <td>Dummy</td>                      
                            <td>Dummy</td>                      
                            <td>Dummy</td> 
                            <td>Dummy</td>   
                            <td>Dummy</td>                   
                        </tr><tr>
                          <td>Dummy</td>
                          <td>Dummy</td>                      
                          <td>Dummy</td>                      
                          <td>Dummy</td>                      
                          <td>Dummy</td> 
                          <td>Dummy</td>   
                          <td>Dummy</td>                   
                      </tr><tr>
                        <td>Dummy</td>
                        <td>Dummy</td>                      
                        <td>Dummy</td>                      
                        <td>Dummy</td>                      
                        <td>Dummy</td> 
                        <td>Dummy</td>   
                        <td>Dummy</td>                   
                    </tr>
                      </tbody>
                  </table>
                </div>
              </div>
              <div class="clear20"></div>
              <div class="whitebox1">
                <label class="bold fs-16 txt-red m-0">Charge Additional Payment</label>
                <div class="clear5"></div>
                <div class="border-bottom"></div>
                <div class="clear5"></div>
                <div class="row">
                    <div class="col-sm-2 col-md-3 col-lg-3 col-xl-3 col-12">
                        <label class="regular fs-14 txt-lightblack2">Amount</label>
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here">
                    </div>
                </div>
                <div class="clear20"></div>
                <button type="button" class="splitPaymentbtn fs-14 bold">Save Payment</button>
              </div>
            </div>
          </div>
        </div>
        </div>
